import {
  getAssignedExperiments,
  mergeExperiments
} from '@/utils/getExperiments'
import type {
  ExperimentName,
  ExperimentVariant,
  IExperiments
} from '@lifk/types'

const OVERRIDABLE_ENVS = ['development', 'staging', 'review', 'test']

function overridesAllowed(): boolean {
  if (import.meta.env.DEV) return true
  const appEnv = import.meta.env.VITE_APP_ENV
  return (
    typeof appEnv === 'string' &&
    OVERRIDABLE_ENVS.includes(appEnv.toLowerCase())
  )
}

function readOverrides(): Record<string, string> {
  const overrides: Record<string, string> = {}
  // For example: "?exp_search_bar=variant_b"
  for (const [key, value] of new URLSearchParams(window.location.search)) {
    if (key.startsWith('exp_')) overrides[key.slice(4)] = value
  }
  return overrides
}

export const assignedExperiments: Partial<IExperiments> =
  getAssignedExperiments()

const experiments: IExperiments = mergeExperiments(
  overridesAllowed()
    ? { ...assignedExperiments, ...readOverrides() }
    : assignedExperiments
)

export function useExperiment<K extends ExperimentName>(
  name: K
): ExperimentVariant<K> {
  return experiments[name]
}
